<script setup lang="ts">
  import type { PropType } from 'vue';
  import type { Section } from '@storefront/types';

  defineProps({
    sections: { type: Array as PropType<Section[]>, required: true },
  });
</script>
<template>
  <main id="main" class="container">
    <SectionRenderer :sections="sections" />
  </main>

  <RouterView />
</template>
